<span *ngIf="hasDateData" class="ai-verified-badge"
  [ngClass]="[isRange ? 'ai-range' : 'ai-single', 'size-' + size, !dateMatchesVisit ? 'ai-date-mismatch' : '']"
  [attr.data-tooltip]="tooltipText">
  <i class="far fa-receipt"></i> {{ displayText }}
</span>
